import type { TOC } from '@ember/component/template-only';

const MobileGenieRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default MobileGenieRouteTemplate;
